import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { ContributionRulesPage } from '../../../features/payroll/contribution-rules-page'

/** Read with payroll.read, changed with payroll.settings. */
export const Route = createFileRoute('/_app/payroll/contributions')({
  staticData: { crumb: 'payrollContributions' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'payroll.read'),
  component: ContributionRulesPage,
})
